import { GET_RELATED_ARTICLES, GET_RELATED_ARTICLES_SUCCESS, GET_RELATED_ARTICLES_FAILURE } from '../constants'


const initialState = {
    records: [],
    isFetching: false,
    error: false
};


export default (state = initialState, action) => {
    switch (action.type) {
        case GET_RELATED_ARTICLES:
            return {
                ...state,
                isFetching: true
            };
        case GET_RELATED_ARTICLES_SUCCESS:
            return {
                ...state,
                records: action.records,
                isFetching: false
            };
        case GET_RELATED_ARTICLES_FAILURE:
            return {
                ...state,
                error: action.error,
                isFetching: false
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/similarNewsArticles.js